import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=4e06a83c&scoped=true&"
import script from "./Recipes.vue?vue&type=script&lang=ts&"
export * from "./Recipes.vue?vue&type=script&lang=ts&"
import style0 from "./Recipes.vue?vue&type=style&index=0&id=4e06a83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06a83c",
  null
  
)

export default component.exports